import { roles } from "constants/index";

export const rolesAction = [roles.admin, roles.departmentManager]

export const rolesAddShop = [roles.admin]

export const rolesActions = [roles.admin]